import React, { useCallback } from 'react';
import { useRouter } from 'next/router';
import * as S from './styles';
import { Event } from '~/utils/helpers';

export type BannerCardProps = {
  dragging?: boolean;
  id: string;
  userId: string;
  external_link: string | null;
  file: string;
  scrolls_to: string | null;
  internal_link:
    | never[]
    | null
    | {
        to: string;
      };
};

type DinamicObject = { [key: string]: () => boolean };

export const BannerCard = (props: BannerCardProps) => {
  const router = useRouter();

  const handleExternalLink = () => {
    window.open(props.external_link!, '_blank');

    return true;
  };

  const handleInternallLink = () => {
    if (Array.isArray(props?.internal_link) || !props.internal_link?.to)
      return false;

    router.push(props.internal_link.to);

    return true;
  };

  const handleScrollsTo = () => {
    const positionElement = document.getElementById(
      props.scrolls_to!
    )?.offsetTop;

    positionElement &&
      window.scrollTo({ top: positionElement, behavior: 'smooth' });

    return true;
  };

  const handleClick = useCallback(
    (e: any) => {
      const keysPriorityOrder = [
        'external_link',
        'internal_link',
        'scrolls_to',
      ];
      const optionsFunctions = {
        external_link: handleExternalLink,
        internal_link: handleInternallLink,
        scrolls_to: handleScrollsTo,
      } as DinamicObject;

      if (props.dragging) return e.stopPropagation();

      Event.push('lineWatchBannerClicked', {
        user_id: props.userId,
        banner_id: props.id,
      });

      for (const key of keysPriorityOrder) {
        const value = (props as unknown as { [key: string]: string | null })[
          key
        ];

        if (value && optionsFunctions[key]) {
          const responseExecution = optionsFunctions[key]();
          if (responseExecution) return;
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      props.dragging,
      props.userId,
      handleExternalLink,
      handleInternallLink,
      handleScrollsTo,
    ]
  );

  return (
    <S.Container onClick={handleClick}>
      <img src={props.file} />
    </S.Container>
  );
};
